"use client";

import {
  Marquee_Img_Vibe_At_Devkrest_Row_1,
  Marquee_Img_Vibe_At_Devkrest_Row_2,
} from "@/lib/dto/careers/vibe-at-devkrest/vibe-at-devkrest-data";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";

function ImgMarqueeSectionVibeDevkrest() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [speed, setSpeed] = useState(15);

  const [shuffledRow1, setShuffledRow1] = useState(Marquee_Img_Vibe_At_Devkrest_Row_1);
  const [shuffledRow2, setShuffledRow2] = useState(Marquee_Img_Vibe_At_Devkrest_Row_2);

  useEffect(() => {
    setShuffledRow1(
      Marquee_Img_Vibe_At_Devkrest_Row_1.slice().sort(() => Math.random() - 0.5)
    );
    setShuffledRow2(
      Marquee_Img_Vibe_At_Devkrest_Row_2.slice().sort(() => Math.random() - 0.5)
    );
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Check if section is in view
      const isVisible = rect.top < viewportHeight && rect.bottom > 0;

      if (isVisible) {
        // Calculate scroll progress through the section
        const scrollPosition = window.scrollY;
        const sectionTop = rect.top + scrollPosition;
        const sectionHeight = rect.height;

        // Calculate how much of the section is scrolled through
        const scrollProgress = Math.max(0, Math.min(1,
          (scrollPosition + viewportHeight - sectionTop) / (viewportHeight + sectionHeight)
        ));

        // Map scroll progress to speed (faster when scrolling through section)
        const baseSpeed = 15;
        const maxSpeed = 60; // Max 4x speed
        const scrollMultiplier = 1 + (scrollProgress * 3); // 1x to 4x speed

        const newSpeed = Math.round(baseSpeed * scrollMultiplier);
        setSpeed(newSpeed);
      } else {
        // Reset to base speed when not in view
        setSpeed(15);
      }
    };

    // Throttle scroll events for better performance
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll);
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, []);

  return (
    <div ref={sectionRef} className="pb-8.5 md:pb-17">
      {/* First Row */}
      <div className="mb-8">
        <Marquee
          autoFill
          gradient
          gradientWidth={50}
          gradientColor="#f7f8fc"
          pauseOnHover
          speed={speed}
          className="w-full"
        >
          <div className="flex gap-x-5 md:gap-x-10 px-2.5 md:px-5 pt-7 md:pt-13 pb-5 md:pb-8.5 xl:pb-8.5">
            {shuffledRow1.map((v, i) => (
              <div
                key={i}
                className="h-[40vh] w-sm sm:h-84 md:h-md md:w-md lg:h-84 lg:w-auto flex justify-center box-border bg-white border-3 md:border-[5px] border-white shadow-md md:shadow-lg xl:shadow-[0px_4px_31.9px_rgba(0,0,0,0.25)] rounded-[20px] flex-shrink-0"
              >
                <Image
                  src={v.image}
                  alt={v.image_alt}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            ))}
          </div>
        </Marquee>
      </div>

      {/* Second Row */}
      <div>
        <Marquee
          autoFill
          gradient
          gradientWidth={50}
          gradientColor="#f7f8fc"
          pauseOnHover
          speed={speed + 10}
          direction="right"
          className="w-full"
        >
          <div className="flex gap-x-5 md:gap-x-10 px-2.5 md:px-5 xl:pt-8.5 pb-5 md:pb-8.5">
            {shuffledRow2.map((v, i) => (
              <div
                key={i}
                className="h-[40vh] w-sm sm:h-84 md:h-md md:w-md lg:h-84 lg:w-auto flex justify-center box-border bg-white border-3 md:border-[5px] border-white shadow-md md:shadow-lg xl:shadow-[0px_4px_31.9px_rgba(0,0,0,0.25)] rounded-[20px] flex-shrink-0"
              >
                <Image
                  src={v.image}
                  alt={v.image_alt}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            ))}
          </div>
        </Marquee>
      </div>
    </div>
  );
}

export default ImgMarqueeSectionVibeDevkrest;
